var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"entries":_vm.filteredToc,"allEntries":_vm.fullToc,"activePage":_vm.activePage,"jump":function (entry) { return _vm.goToEntry(entry); }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }